export default __webpack_public_path__ + "static/media/IMG_2941.3bc71e1e.jpg";